import $ from "jquery";
import 'hammerjs';
import sqftConfig from "./sqftConfig";
import sqftCursorManager from "./sqftCursorManager";

const sqftEventManager = {
  renderEvents: [],
  renderEventsSlab: [],
  priorities: {
    OVERALL: -100,
    SLAB_RIGHT_PART_CONTENT: -40,
    SLAB_RIGHT_PART_WORKSPACE: -30,
    BOX_POINT: -5,
    BOX: -1,
    OVERLAY: 0,
    IMAGE_LINE: 1,
    IMAGE: 3,
    POINT: 5,
    SEGMENT_MEASUREMENTS: 7,
    SEGMENT: 10,
    SHAPE_LABEL: 12,
    APPLIANCE_ON_TOP_SHAPE: 12,
    SHAPE_UPPER: 14.5,
    SHAPE: 15,
    SHAPE_SLAB_PLACEHOLDER: 15.5,
    APPLIANCE_ON_BOTTOM_SHAPE: 17,
    WALL: 18,
    SLAB_IMAGE: 20,
    SLAB_LEFT_PART: 25,
    WORKSPACE: 100,
  },
  events: {
    MOUSE_MOVE: "mousemove",
    MOUSE_DOWN: "mousedown",
    MOUSE_UP: "mouseup",
    MOUSE_WHEEL: "mousewheel",
    WHEEL: "wheel",
    ON_MOUSE_WHEEL: "onmousewheel",
    RESIZE: "resize",
    TOUCH_START: "touchstart",
    TOUCH_END: "touchend",
    TOUCH_MOVE: "touchmove",
    TOUCH_CANCEL: "touchcancel",
    MOUSE_LEAVE: "mouseleave",
    CLICK: "click",
    DBLCLICK: "dblclick",
    CONTEXTMENU: "contextmenu",
    KEYDOWN: "keydown",
    RENDER: "render",
    DRAG_OVER: "dragover",
    DROP: "drop"
  },
  keyCode: {
    ENTER: "Enter",
    NumpadEnter: "NumpadEnter"
  },
  self: this,
  activeEvents: [],
  canvas: null,
  $canvas: null,
  _offscreenCanvas: null,
  canvasOffset: null,
  ctx: null,
  state: {
    processing: false
  },
  eventQueue: [],
  G_events: { //events to tie into the Quoting Tool's Global Events for Idle timeout
    userIdleStartTimer: 'userIdleStartTimer',
    userIdleWarning: 'userIdleWarning',
    userIdleTimeOut: 'userIdleTimeOut',
    userIdleStopTimer: 'userIdleStopTimer',
    userIdleGoHome: 'userIdleGoHome',
    userIdleGoHomeCountdown: 'userIdleGoHomeCountdown'
  },
  hammer: null,
  hammerMC: null,
  LastKnownMousePos: null,
  //currentCursorOwner: null,
  //currentCursor: null,
  //noCursorStealing: false,
  zoomLock: null,
  resizeHandler: null,
  keydownHandler: null,

  getCtx: function() {
    return this.ctx ? this.ctx : this.getOffScreenCtx();
  },
  getOffScreenCtx: function() {
    return this.getOffScreenCanvas().getContext('2d');
  },
  getOffScreenCanvas: function() {
    if (!this._offscreenCanvas) {
      const c = document.createElement('canvas');
      c.width = 800;
      c.height = 800;
      this._offscreenCanvas = c;
      return this._offscreenCanvas
    }
    return this._offscreenCanvas;
  },
  eventSort: function (a, b) {
    if (a.priority < b.priority)
      return -1;
    if (a.priority > b.priority)
      return 1;
    return 0;
  },
  getMousePos: function (e) {
    if (!e) {
      return this.LastKnownMousePos;
    }
    this.LastKnownMousePos = {
      x: e.pageX - this.canvasOffset.left,
      y: e.pageY - this.canvasOffset.top
    };
    return this.LastKnownMousePos;
  },
  getTouchPos: function(e) {
    let x, y;
    // TouchEvent
    if (e.changedTouches && e.changedTouches.length) {
      const t = e.changedTouches[0];
      x = t.pageX;
      y = t.pageY;
    }
    // HammerInput (coordinates e.center)
    else if (e.center && typeof e.center.x === "number") {
      x = e.center.x;
      y = e.center.y;
    } else {
      // fallback
      return this.LastKnownMousePos;
    }

    this.LastKnownMousePos = {
      x: x - this.canvasOffset.left,
      y: y - this.canvasOffset.top
    };
    return this.LastKnownMousePos;
  },
  setCanvas: function(value) {
    this.canvas = value;
    this.$canvas = $(value);
    this.ctx = this.canvas.getContext('2d');
    sqftCursorManager.init(this.canvas);
  },
  onMouseMove: function(mousepos, e) {
    let mousemove = this.activeEvents[this.events.MOUSE_MOVE] || [];
    e.terminate = false;
    for (var i = 0; i < mousemove.length; i++) {
      if (mousemove[i].event.call(mousemove[i].sender, mousepos, e)) {
        e.terminate = true;
      }
    }
  },
  onMouseUp: function(mousepos, e) {
    var mouseup = this.activeEvents[this.events.MOUSE_UP] || [];
    for (var i = 0; i < mouseup.length; i++) {
      if (mouseup[i].event.call(mouseup[i].sender, mousepos, e)) {
        break;
      }
    }
  },
  onMouseDown: function(mousepos, e, callback) {
    var mousedown = this.activeEvents[this.events.MOUSE_DOWN] || [];
    for (var i = 0; i < mousedown.length; i++) {
      if (mousedown[i].event.call(mousedown[i].sender, mousepos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousepos, e);
    }
  },
  onMouseLeave: function(mousepos, e, callback) {
    var mouseleave = this.activeEvents[this.events.MOUSE_LEAVE] || [];
    for (var i = 0; i < mouseleave.length; i++) {
      if (mouseleave[i].event.call(mouseleave[i].sender, mousepos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousepos, e);
    }
  },
  onKeyDown: function (code, e, callback) {
    let mouseleave = this.activeEvents[this.events.KEYDOWN] || [];
    for (let i = 0; i < mouseleave.length; i++) {
      if (mouseleave[i].event.call(mouseleave[i].sender, code, e)) {
        e.preventDefault();
        e.stopPropagation();
        break;
      }
    }
    if (callback) {
      callback(code, e);
    }
  },
  onDblClick: function(mousepos, e, callback) {
    let mousedown = this.activeEvents[this.events.DBLCLICK] || [];
    for (let i = 0; i < mousedown.length; i++) {
      if (mousedown[i].event.call(mousedown[i].sender, mousepos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousepos, e);
    }
  },
  onWheel: function(mousePos, e, callback) {
    let wheel = this.activeEvents[this.events.WHEEL] || [];
    for (let i = 0; i < wheel.length; i++) {
      if (wheel[i].event.call(wheel[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onResize: function(e) {
    let resize = this.activeEvents[this.events.RESIZE] || [];
    for (let i = 0; i < resize.length; i++) {
      if (resize[i].event.call(resize[i].sender, e)) {
        break;
      }
    }
    this.updateOffset(e);
  },
  onContextmenu: function(mousePos, e, callback) {
    let contextmenu = this.activeEvents[this.events.CONTEXTMENU] || [];
    for (let i = 0; i < contextmenu.length; i++) {
      if (contextmenu[i].event.call(contextmenu[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onDrop: function(mousePos, e, callback) {
    let dragEvents = this.activeEvents[this.events.DROP] || [];
    for (let i = 0; i < dragEvents.length; i++) {
      if (dragEvents[i].event.call(dragEvents[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onDragOver: function(mousePos, e, callback) {
    let dragOverEvents = this.activeEvents[this.events.DRAG_OVER] || [];
    for (let i = 0; i < dragOverEvents.length; i++) {
      if (dragOverEvents[i].event.call(dragOverEvents[i].sender, mousePos, e)) {
        break;
      }
    }
    if (callback) {
      callback(mousePos, e);
    }
  },
  onTouchCancel: function() {
    onMouseUp(this.LastKnownMousePos, {});
    this.LastKnownMousePos = {x: 0, y: 0};
    onMouseMove(this.LastKnownMousePos, {});
  },
  onRender: function() {
    var render = this.activeEvents[this.events.RENDER] || [];
    var triangles = [];
    for (var i = render.length - 1; i >= 0; i-- ) {
      if (render[i] === undefined) {
        continue
      }
      var result = render[i].event.call(render[i].sender, this.getCtx());
      if (render[i] !== undefined && render[i].priority === this.priorities.SHAPE) {
        triangles.push(result);
      }
    }
    return triangles;
  },
  updateOffset: function() {
    this.canvasOffset = $(this.canvas).offset();
  },
  trigger: function(event, e) {
    let response = null;
    switch(event) {
      case this.events.MOUSE_MOVE:
      case this.events.TOUCH_MOVE:
        response = this.onMouseMove(this.getMousePos(e), e);
        break;
      case this.events.MOUSE_WHEEL:
      case this.events.WHEEL:
      case this.events.ON_MOUSE_WHEEL:
        console.log("WHEEL");
        break;
      case this.events.MOUSE_UP:
      case this.events.TOUCH_END:
        response = this.onMouseUp(this.getMousePos(e), e);
        break;
      case this.events.MOUSE_DOWN:
      case this.events.TOUCH_START:
        response = this.onMouseDown(this.getMousePos(e), e);
        break;
      case this.events.TOUCH_CANCEL:
        response = this.onTouchCancel();
        break;
      case this.events.RESIZE:
        response = this.onResize(e);
        break;
      case this.MOUSE_LEAVE:
        response = this.onMouseLeave(e);
        break;
      case this.CONTEXTMENU:
        response =  this.onContextmenu(this.getMousePos(e), e);
        break;
      case this.DBLCLICK:
        response = this.onDblClick(this.getMousePos(e), e);
        break;
      case this.events.RENDER:
        response = this.onRender();
        break;
    }
    return response;
  },
  pinchToZoom: function(event) {
    const stepSize = 0.04;

    // simple throttle
    if (this.zoomLock) {
      return;
    }

    this.zoomLock = window.setTimeout(() => {
      // clear zoomLock on sqftEventManager instance
      this.zoomLock = null;
    }, 10);

    let mod = 0;

    if (event.additionalEvent === "pinchin") {
      mod = -1;
    } else if (event.additionalEvent === "pinchout") {
      mod = 1;
    }

    if (!mod) {
      return;
    }

    let scale = sqftConfig.scale + mod * stepSize;

    if (scale < 1) scale = 1;
    else if (scale > 10) scale = 10;

    sqftConfig.setScale(scale);
  },

  init: function(canvas) {
    if (this.canvas === canvas && this.canvas.isWithEventManager) {
      return;
    }

    if (this.canvas && this.canvas !== canvas) {
      if (this.hammerMC) {
        this.hammerMC.destroy(); // destroy old manager
        this.hammerMC = null;
      }
      if (this.hammer) {
        this.hammer.destroy(); // destroy old hammer instance
        this.hammer = null;
      }
    }

    this.setCanvas(canvas);
    if (!this.hammerMC) {
      this.hammerMC = new Hammer.Manager(canvas);
      this.hammerMC.add(new Hammer.Pinch({ enable: true }));
      this.hammerMC.on("pinch", (ev) => {
        this.pinchToZoom(ev);
      });
    }

    if (!this.hammer) {
      this.hammer = new Hammer(canvas);

      // Configure press gesture
      const press = new Hammer.Press({
        time: 500, // Duration in ms for press to trigger (default 251ms)
        threshold: 9 // Maximum movement allowed during press (default 9px)
      });

      this.hammer.add(press);

      this.hammer.on("doubletap", (e) => {
        if (!e.handled) {
          this.eventQueue.push([this.events.DBLCLICK, this.getMousePos(e), e]);
          this.processEventQueue();
        }
      });

      this.hammer.on("press", (e) => {
        if (!e.handled) {
          const pos = this.getTouchPos(e.srcEvent);
          const fakeEvent = {
            ...e.srcEvent,
            handled: true,
            type: "contextmenu",
          };

          this.eventQueue.push([this.events.CONTEXTMENU, pos, fakeEvent]);
          this.processEventQueue();
        }
      });
    }

    this.resizeHandler = this.onResize.bind(this);
    window.addEventListener(this.events.RESIZE, this.resizeHandler);

    this.keydownHandler = function (e) {
      // e.preventDefault();
      // e.stopPropagation();
      if (event.isComposing || event.keyCode === 229) {
        return;
      }

      if (window.__suspendShortcuts) { // bugfix for line-input
        return;
      }

      //console.log("code", e.code);
      //console.log("keyCode", e.keyCode);
      this.eventQueue.push([this.events.KEYDOWN, e.code, e]);
      this.processEventQueue();
    }.bind(this);
    window.addEventListener(this.events.KEYDOWN, this.keydownHandler);

    canvas.addEventListener(this.events.MOUSE_MOVE, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.eventQueue.length > 2 &&
        this.eventQueue[this.eventQueue.length - 1][0] === this.events.MOUSE_MOVE &&
        this.eventQueue[this.eventQueue.length - 2][0] === this.events.MOUSE_MOVE
      ) {
        this.eventQueue[this.eventQueue.length - 1] = [this.events.MOUSE_MOVE, this.getMousePos(e), e];
      } else {
        this.eventQueue.push([this.events.MOUSE_MOVE, this.getMousePos(e), e]);
      }
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([this.events.DRAG_OVER, this.getMousePos(e), e]);
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([this.events.DROP, this.getMousePos(e), e]);
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener(this.events.MOUSE_DOWN, function(e){
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([this.events.MOUSE_DOWN, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.MOUSE_UP, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([this.events.MOUSE_UP, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.TOUCH_START, function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.handled = true;
      if (e.touches.length === 1) {
        let touchPos = this.getTouchPos(e);
        this.eventQueue.push([this.events.MOUSE_MOVE, touchPos, e]);
        this.eventQueue.push([this.events.TOUCH_START, touchPos, e]);
        this.processEventQueue();
      }
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.TOUCH_END, function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.handled = true;
      this.eventQueue.push([this.events.TOUCH_END, this.getTouchPos(e), e]);
      this.processEventQueue();
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.TOUCH_CANCEL, function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([this.events.TOUCH_CANCEL, this.getTouchPos(e), e]);
      this.processEventQueue();
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.TOUCH_MOVE, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.zoomLock || e.touches.length > 1) //do not move when multi-touch or zoom locked or if the finger-move jumps too far
        return;
      let touchPos = this.getTouchPos(e);
      if (this.eventQueue.length > 2 &&
        this.eventQueue[this.eventQueue.length - 1][0] === this.events.TOUCH_MOVE &&
        this.eventQueue[this.eventQueue.length - 2][0] === this.events.TOUCH_MOVE
      ) {
        this.eventQueue[this.eventQueue.length - 1] = [this.events.TOUCH_MOVE, this.getTouchPos(e), e];
      } else {
        this.eventQueue.push([this.events.TOUCH_MOVE, touchPos, e]);
      }
      this.processEventQueue();
    }.bind(this), { passive: false });
    canvas.addEventListener(this.events.MOUSE_LEAVE, function(e) {
      e.preventDefault();
      e.stopPropagation();
      this.eventQueue.push([this.events.MOUSE_LEAVE, this.getMousePos(e), e]);
      this.processEventQueue();
    }.bind(this));
    canvas.addEventListener(this.events.DBLCLICK, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([this.events.DBLCLICK, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.WHEEL, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([this.events.WHEEL, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    canvas.addEventListener(this.events.CONTEXTMENU, function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.handled) {
        this.eventQueue.push([this.events.CONTEXTMENU, this.getMousePos(e), e]);
        this.processEventQueue();
      }
    }.bind(this));
    this.updateOffset();
    this.resetCursor(null);
    this.canvas.isWithEventManager  = true;
  },
  clearAll: function() {
    window.removeEventListener(this.events.RESIZE, this.resizeHandler);
    window.removeEventListener(this.events.KEYDOWN, this.keydownHandler);

    this.activeEvents = [];
    this.eventQueue = [];
    this.LastKnownMousePos = {
      x: -1,
      y: -1
    };
  },
  stealCursor: (override, revertBackAfterMouseUp) => {
    return sqftCursorManager.stealCursor(override, revertBackAfterMouseUp);
  },
  releaseStealLock: (owner) => {
    return sqftCursorManager.releaseStealLock(owner);
  },
  setCursor: (cursor, owner, noStealing) => {
    return sqftCursorManager.setCursor(cursor, owner, noStealing);
  },
  setCursorImage: (cursorImage, owner, noStealing) => {
    return sqftCursorManager.setCursorImage(cursorImage, owner, noStealing);
  },
  resetCursor: (owner) => {
    return sqftCursorManager.resetCursor(owner);
  },
  getCursor: () => {
    return sqftCursorManager.getCursor();
  },
  event: function(callback, sender, priority) {
    this.event = callback;
    this.sender = sender;
    this.priority = priority;
  },
  addEvent: function(event, callback, sender, priority) {
    var e = new this.event(callback, sender, priority);
    this.activeEvents[event] = this.activeEvents[event] || [];
    this.activeEvents[event].unshift(e);
    this.activeEvents[event].sort(this.eventSort);
  },
  removeEvent: function(sender, event) {
    let i;
    if (typeof(event) === 'undefined') {
      event = null;
    } else {
      event = event.toLowerCase();
    }
    if (event === null) {
      for (var key in this.activeEvents) {
        for (i = this.activeEvents[key].length -1; i >= 0; i--) {
          // lodash compare variant
          // if (_.isEqual(this.activeEvents[key][i].sender, sender)) {
          if (this.activeEvents[key][i].sender === sender) {
            this.activeEvents[key].splice(i, 1);
          }
        }
      }
    } else if (this.activeEvents[event]?.length > 0) {
      for (i = this.activeEvents[event].length - 1; i >= 0; i--) {
        if (this.activeEvents[event][i].sender === sender) {
          this.activeEvents[event].splice(i, 1);
        }
      }
    }
  },
  removeStuckCursorEvents: function() {
    let mouseupEvents = this.activeEvents[this.events.MOUSE_UP] || [];
    for (const mouseupEvent of mouseupEvents) {
      const isCursorExist = mouseupEvent.sender.cursorImage || mouseupEvent.sender.cursor;
      if (isCursorExist && mouseupEvent.sender && mouseupEvent.sender.destroy) {
        mouseupEvent.sender.destroy(true, false);
      }
    }
  },
  processEventQueue: function() {
    if (!this.state.processing) {
      this.state.processing = true;
      let e;
      while( (e = this.eventQueue.shift()) ) {
        if (e[1] == null) {
          continue;
        }
        switch(e[0]) {
          case this.events.MOUSE_DOWN:
          case this.events.TOUCH_START:
            this.onMouseDown(e[1], e[2]);
            break;
          case this.events.MOUSE_MOVE:
          case this.events.TOUCH_MOVE:
            this.onMouseMove(e[1], e[2]);
            break;
          case this.events.MOUSE_UP:
          case this.events.TOUCH_END:
            this.onMouseUp(e[1], e[2]);
            break;
          case this.events.DBLCLICK:
            this.onDblClick(e[1], e[2]);
            break;
          case this.events.TOUCH_CANCEL:
            this.onTouchCancel();
            break;
          case this.events.MOUSE_LEAVE:
            this.onMouseLeave(e[1], e[2]);
            break;
          case this.events.RESIZE:
            this.onResize(e[1], e[2]);
            break;
          case this.events.MOUSE_WHEEL:
          case this.events.WHEEL:
          case this.events.ON_MOUSE_WHEEL:
            this.onWheel(e[1], e[2]);
            break;
          case this.events.KEYDOWN:
            this.onKeyDown(e[1], e[2]);
            break;
          case this.events.CONTEXTMENU:
            this.onContextmenu(e[1], e[2]);
            break;
          case this.events.DRAG_OVER:
            this.onDragOver(e[1], e[2]);
            break;
          case this.events.DROP:
            this.onDrop(e[1], e[2]);
            break;
        }
      }
    }
    this.state.processing = false;
    //window.resetIdleTimer(); //todo sqft-react is this needed
  }
};

export default sqftEventManager
